<template>
    <div id="n-table">
        <el-table ref="moduleTable"
            border
            :highlight-current-row = "tableList.highlight"
            :height="tableList.height"
            :data="tableData"
            tooltip-effect='dark'
            v-loading="loading"
            @current-change="handleCurrentChange"
            @select-all="selectAll"
            @selection-change="handleSelectionChange"
            @row-click='rowClick'
            @row-dblclick="rowDBclick"
        >
            <!-- 单选框 -->
            <el-table-column
                label=""
                align="center"
                v-if="tableList.radio"
                width="40">
            <template slot-scope="scope">
                <el-radio v-model="tableList.checked" :label="scope.row.itemCode"></el-radio>
            </template>
            </el-table-column>
            <!-- 是否多选 selectBtn 实现多选非常简单: 手动添加一个el-table-column，设type属性为selection即可 -->
            <el-table-column type="selection" width="40" fixed v-if="tableList.selectBtn"></el-table-column>
            <el-table-column
              type="index"
              align="left"
              :label="$translate('lang.E3202101260027', { defaultText: '序号' })"
              :fixed='true'
              width="50">
            </el-table-column>
            <!-- 循环遍历展示 -->
            <el-table-column
                :show-overflow-tooltip="item.type === 'hint'? false: true"
                v-for="(item, index) in tableList.columns"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :fixed='item.fixed'
                :align="item.align"
                :sortable="item.sort"
                :min-width="item.width?item.width : ''">
                <template slot="header">
                    <el-tooltip class="item" effect="dark" :content="item.label" placement="top-start">
                        <span>{{item.label}}</span>
                    </el-tooltip>
                </template>
                <template slot-scope="scope">
                    <div>
                        <div v-if="item.type === 'switch'" @click="stopClick">
                            <el-switch
                                class="demo"
                                v-model="scope.row[item.prop]"
                                :disabled="scope.showScope"
                                @change="switchChange(scope.row,item, scope.$index)"
                                active-value="Y"
                                inactive-value="N"
                                :active-text="item.statesY"
                                :inactive-text="item.statesN">
                            </el-switch>
                        </div>
                        <div v-else-if="item.type === 'hint'" >
                            <span @click="()=>handleView(scope.row[item.prop], item.label)" class="line-limit">{{scope.row[item.prop]}}</span>
                        </div>
                        <div v-else-if="item.type === 'underLine'" >
                            <span @click="()=>handleDetail(scope.row)" class="underLine">{{scope.row[item.prop]}}</span>
                        </div>
                        <div v-else :style="{color:scope.row[item.prop+'Color']}">
                            {{scope.row[item.prop]}}
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :width="tableList.leftWidth?tableList.leftWidth : ''"
                v-if="tableList.leftOperation"
                fixed="right"
                :label="$translate('lang.E3202102230005', { defaultText: '操作' })">
                <template slot-scope="scope">
                    <el-button
                        v-for="(item, index) in tableList.action"
                        :key="index"
                        @click.stop="btnEvent(scope.row,item.event)"
                        :type="item.type"
                    >
                        {{item.label}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog
                :title="title"
                :visible.sync="dialogVisible"
                width="40%">
                <!-- <pre v-for="(item,index) in params" :key="index" class="show-json">{{item}}</pre> -->
                <div class="dialogVisible">{{params}}</div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: {
        tableList: {
            type: Object,
            default() {
                return {
                    highlight: false
                };
            }
        },
        loading: {
            type: Boolean,
            default() {
                return false;
            }
        },
        tableData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            // 选中
            selectedRowsData: [],
            dialogVisible: false,
            params: '',
            title: ''
        };
    },
    mounted() {
        // console.log(this.tableList);
    },
    methods: {
        handleDetail(data) {
            this.$emit('handleDetail', data);
        },
        handleView(data, label) {
            this.params = '';
            this.title = '';
            this.dialogVisible = true;
            this.params = data;
            this.title = label;
        },
        // 启用停用
        switchChange(data, item, num) {
            if (this.tableList.switchType) {
                this.$emit('switch-change', data);
            } else {
                if (data.status === 'Y') {
                    this.$confirm('是否启用?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '启用成功!'
                        });
                        this.$emit('switch-change', data);
                    }).catch(() => {
                        this.tableData[num][item.prop] = 'N';
                    });
                } else {
                    this.$confirm('是否停用?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '停用成功!'
                        });
                        this.$emit('switch-change', data);
                    }).catch(() => {
                        this.tableData[num][item.prop] = 'Y';
                    });
                }
            }
        },
        selectAll() {
            if (this.tableList.isSingleSelect) {
                this.$refs.moduleTable.clearSelection();
            }
        },
        handleSelectionChange(selection) {
            // this.selectedRowsData = selection;
            // this.$emit('onSelectionChange', selection);
            if (this.tableList.isSingleSelect && selection.length >= 2) {
                const removeItem = selection[0];
                this.$refs.moduleTable.toggleRowSelection(removeItem);
                this.selectedRowsData = selection.splice(0, 1);
            } else {
                this.selectedRowsData = selection;
            }
            this.$emit('onSelectionChange', selection);
        },
        rowClick(rows) {
            let checked = false;
            this.selectedRowsData.map(item => {
                if (item === rows) {
                    checked = true;
                }
            });
            if (rows) {
                rows = [rows];
                rows.forEach(row => {
                    if (checked) {
                        this.$refs.moduleTable.toggleRowSelection(row, false);
                    } else {
                        this.$refs.moduleTable.toggleRowSelection(row, true);
                    }
                });
            }
        },
        rowDBclick(data) {
            this.$emit('rowDBclick', data);
        },
        handleCurrentChange(data) {
            this.$emit('handleCurrentChange', data);
        },
        stopClick() {
            event.stopPropagation();
        },
        // 操作
        btnEvent(selection, event) {
            this.$emit('btn-event', selection, event);
        }
    }
};
</script>
<style lang="less">
#n-table {
        .el-table__body tr.selected-row > td {
                background: #F1F8FA !important;
        }

        .error-active input {
            border-color: red;
        }

        .demo .el-switch__label {
            position: absolute;
            display: none;
            color: #fff;
        }

        /*打开时文字位置设置*/

        .demo .el-switch__label--right {
            z-index: 1;
            right: -6px;
            top: 2px;
        }

        /*关闭时文字位置设置*/

        .demo .el-switch__label--left {
            z-index: 1;
            left: 24px;
            top: 2px;
        }

        /*显示文字*/

        .demo .el-switch__label.is-active {
            display: block;
        }

        .demo.el-switch .el-switch__core,
        .el-switch .el-switch__label {
            width: 55px !important;
        }
        .el-button--text{
            padding: 7px 0;
        }
        .line-limit {
            color: #4285f5;
            cursor: pointer;
        }
        .underLine{
            color: #4285f5;
            cursor: pointer;
            text-decoration:underline;
        }
        .dialogVisible {
            height: 30vh;
            overflow: auto;
        }
}
</style>
